import React from 'react';
import './Main.scss';
import classNames from 'classnames';

import {
    Localizations,
    PROCESSES_LOADED_PDF,
    PROCESSES_LOADED_SITE,
    SOCKET_STATUSES,
    StatesLoadForm,
    STATUS_LOAD,
} from '../../common/const/const';

const Main = ({...props}) => {
    const isSiteUpdate = props.activeTab.indexOf('site') !== -1;
    const LocalizationsKeys = Object.keys(Localizations);
    const Localization = {};
    LocalizationsKeys.map((key) => {
        if (props.activeTab === `${key}_load_site`
            || props.activeTab === `${key}_load_pdf`) {
            Localization.key = key;
        }
    });
    return (
        <div className="Main__container">
            <div className="Main__menu-country">
                {LocalizationsKeys.map((key, index) => (
                    <div className="Main__menu-country_item" key={index.toString()}>
                        <div>{Localizations[key].name}</div>
                        <div
                            className={classNames('noactive', {'active': props.activeTab === `${key}_load_site`})}
                            onClick={() => props.onChangeTab(`${key}_load_site`)}
                        >
                            Обновление сайта
                        </div>
                        <div
                            className={classNames('noactive', {'active': props.activeTab === `${key}_load_pdf`})}
                            onClick={() => props.onChangeTab(`${key}_load_pdf`)}
                        >
                            Загрузить файл
                        </div>
                    </div>
                ))}
            </div>
            <div className="Main__content">
                <div className="Main__title">
                    {isSiteUpdate ? 'Обновление сайта ' : 'Загрузка pdf на '}
                    {Localizations[Localization.key].name}
                </div>
                <div className="Main__content-form">
                    <Form
                        isSiteUpdate={isSiteUpdate}
                        {...props}
                    />
                </div>
            </div>
        </div>
    );
};

const Form = ({
    activeStateForm,
    isSiteUpdate,
    handleChangeFile,
    formFile,
    handleLoadFile,
    statesLoadFile,
    handleLoadNewFile,
}) => {
    const chooseTypeText = isSiteUpdate ? 'Выберите архив' : 'Выберите файл';
    const textFile = ((formFile && formFile.name) || chooseTypeText).length > 30
        ? `${((formFile && formFile.name) || chooseTypeText).slice(0, 30)}...` : ((formFile && formFile.name) || chooseTypeText);
    switch (activeStateForm) {
    case StatesLoadForm.chooseFile:
        return (
            <div className="Form__load-file-content">
                <label>
                    <div className="Form__file-label">{textFile}</div>
                    <input
                        type="file"
                        accept={isSiteUpdate ? ".rar, .zip, .7z, .zipx" : ".pdf, .crl, .crt"}
                        onChange={handleChangeFile}
                        onClick={(event) => {event.target.value = null}}
                    />
                </label>
                <button
                    className="Form__file-button"
                    onClick={handleLoadFile}
                >
                    {isSiteUpdate ? 'Обновить сайт' : 'Загрузить файл'}
                </button>
            </div>
        );
    case StatesLoadForm.loadFile:
        if (!statesLoadFile) return null;
        const keysStatesLoadFile = Object.keys(statesLoadFile);
        return (
            <div className="Form__process-load_content">
                <div className="Form__process-load_file-name">{textFile}</div>
                {statesLoadFile && keysStatesLoadFile.map((key, index) => (
                    <div className="Form__process-load_processes-item" key={index.toString()}>
                        {isSiteUpdate ? PROCESSES_LOADED_SITE[key] : PROCESSES_LOADED_PDF[key]}
                        <span
                            className={classNames('status', {'success': statesLoadFile[key] === STATUS_LOAD.success })}
                        >
                            {statesLoadFile[key]}
                            {statesLoadFile[key] === STATUS_LOAD.load && <div className="spinner" />}
                        </span>
                    </div>
                ))}
                {keysStatesLoadFile.indexOf(SOCKET_STATUSES.done) !== -1 && statesLoadFile.done === STATUS_LOAD.success && (
                    <button
                        className="Form__file-button"
                        onClick={handleLoadNewFile}
                        style={{width: '250px'}}
                    >
                        Загрузить новый {isSiteUpdate ? 'архив' : 'файл'}
                    </button>
                )}
            </div>
        );
    default:
        return null;
    }
};

export default Main;
